"use client";

import { Trash2, LucideIcon } from "lucide-react";
import styles from "./BulkActionsBar.module.css";

export interface BulkAction {
  label: string;
  icon?: LucideIcon;
  onClick: () => void;
  variant?: "danger" | "primary" | "secondary";
}

interface BulkActionsBarProps {
  selectedCount: number;
  itemName: string; // e.g., "danh mục", "tin tức", "sản phẩm"
  actions: BulkAction[];
}

export default function BulkActionsBar({ selectedCount, itemName, actions }: BulkActionsBarProps) {
  if (selectedCount === 0) return null;

  return (
    <div className={styles.bulkActions}>
      <span className={styles.bulkActionsText}>
        Đã chọn {selectedCount} {itemName}
      </span>
      <div className={styles.bulkActionsButtons}>
        {actions.map((action, index) => {
          const Icon = action.icon || Trash2;
          const variant = action.variant || "danger";
          
          return (
            <button
              key={index}
              className={`${styles.bulkActionBtn} ${styles[`bulkActionBtn${variant.charAt(0).toUpperCase() + variant.slice(1)}`]}`}
              onClick={action.onClick}
            >
              <Icon size={16} />
              {action.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

